// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"0d5fe0f8","355":"e2d2cd3b","453":"0c626c0a","469":"79e0d0f1","470":"6d964375","787":"bb20b309","886":"71f7be59"}[chunkId] + ".chunk.js";
};